import { isDeploymentFeatureEnabled } from "@/shared/config/deployment-features"
import { DeploymentFeatureGate } from "@/shared/ui/deployment-feature-gate"
import { fetchBonuses } from "@/entities/bonus"
import { fetchCommunityInfo, fetchWallets } from "@/entities/community"
import { fetchCommunitySectionsAvailability } from "@/entities/community-sections-availability"
import { fetchEmployeesGroups, fetchUsersGroups } from "@/entities/groups"
import { fetchPartners, fetchStores, fetchOEMGroups } from "@/entities/partner"
import { fetchTradingWallet } from "@/entities/trading"
import { useAppDispatch } from "@/shared/lib/redux"
import { ErrorBoundary } from "@/shared/ui/error-boundary"
import { PageOutlet } from "@/shared/ui/page-outlet/page-outlet"
import { Modals } from "@/widgets/modals"
import { Sidebar } from "@/widgets/sidebar"
import { SupportBot } from "@/widgets/support-bot"
import { useEffect } from "react"

export const Layout = () => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(fetchBonuses())
        dispatch(fetchWallets())
        dispatch(fetchUsersGroups())
        dispatch(fetchEmployeesGroups())
        dispatch(fetchCommunitySectionsAvailability())
        dispatch(fetchCommunityInfo()).unwrap().then((community) => {
            if (community.type === 'partner') {
                dispatch(fetchPartners())
                dispatch(fetchStores())
                dispatch(fetchOEMGroups())
            }
            if (isDeploymentFeatureEnabled('trading') && (community.type === 'partner' || community.type === 'foundation' || community.type === 'manufacturer')) {
                dispatch(fetchTradingWallet())
            }
        })
    }, [])

    return (
        <div className="w-full flex flex-1 min-h-0">
            <Sidebar />
            <ErrorBoundary>
                <DeploymentFeatureGate>
                    <PageOutlet />
                </DeploymentFeatureGate>
            </ErrorBoundary>
            <Modals />
            <SupportBot />
        </div>
    )
}
